app.service('companyName', function () {
	function prepare(value) {
		value = '' + clean(value);
		return [value, value.substr(0, 80), value.substr(80, 80)]; // [0] wszystko, [1] pierwsza część, [2] druga część
	}
	function clean(text) {
		return text.replace(/(<([^>]+)>)/g, '').trim();
	}
	function init(prefix) {
		let $input1 = $('#' + prefix);
		if ($input1.length) {
			let $input2 = $('#' + prefix + '-cd');
			let $textarea = $('#' + prefix + '-textarea');
			let $div = $('#' + prefix + '-textarea-div');
			let $form = $input1.closest('form');
			$input1.ignore(true);
			$input2.ignore(true);
			$div.on('input', function () {
				var value = prepare($div.text());
				$textarea.val(value[0]);
				$input1.val(value[1]);
				$input2.val(value[2]);
				//if ($textarea.hasClass('error') || value[0].length > 160 || value[0].length == 0) {
					if($form.data('validator')){
						$form.validate().element($textarea);
					}
				//}
			}).on('focus', function () { 
				$(this).closest('.column').addClass('input-focus');
			}).on('blur', function () {
				$(this).closest('.column').removeClass('input-focus');
			});
		}
	}
	return {
		init
	};
});